import React, { memo } from "react";
import styled from "styled-components";
import { LazyLoadImage } from "react-lazy-load-image-component";

const ItemAnswerType = memo(({ className, itemAnswer, onSelected }) => {
  return (
    <div className={className}>
      <div onClick={onSelected} className={"variation-tab"}>
        <div className="flex items-center justify-center">
          {itemAnswer?.["image"] && (
            <LazyLoadImage
              src={
                !itemAnswer?.isSelected
                  ? itemAnswer?.["inactive-image"]
                  : itemAnswer?.["image"]
              }
              className="rounded-md"
              style={{ width: 40, height: 40 }}
              alt="product image"
            />
          )}
        </div>
      </div>
    </div>
  );
});

export default styled(ItemAnswerType)`
  position: relative;
  width: 80px;
  .variation-tab {
    width: 80px;
    justify-content: center;
    display: relative;
  }
  .text-amount {
    text-align: center;
    color: #1a1a1a;
    &.active {
      color: #b98803;
    }
  }
`;
